import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AccountUserService } from '../service/account.service';
import { Observable } from 'rxjs';
import { HttpService } from '../modules/shared/services/http.service';
import { UserPreference } from '../modules/shared/models/user-preference/user-preference.model';
import { ProfileImageData } from './models/profile-image.model';

@Injectable()
export class ProfileService {

    appUrl = "";
    localAppUrl = "";
    messApi = '';
    appUrlStream = "";
    activity = "";
    activityNote = "";
    user: any;
    notificationUrl = "";
    loginAppUrl ="";

    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    constructor(private http: HttpClient, private accountUserService: AccountUserService,
        private httpService: HttpService) {

        this.accountUserService.user.subscribe(x => this.user = x);
        this.appUrl = environment.appOrgUrlconfig + "User";
        this.messApi = environment.apiStreamUrl;
        this.localAppUrl = environment.localApiUrl;
        this.loginAppUrl = environment.appOrgUrlconfig +"Login";

    }


    getuserLoggedIn(date) {
        let url = `${this.loginAppUrl}/GetLastLoginHistory?ToDate=${date}`;
        return this.http.get<any>(url).toPromise()
        .then(res => res);
    }

    getuserProfile() {
        let url = this.appUrl+ "/" + this.user.userId;
        return this.http.get<any>(url).toPromise()
            .then(res => res);
    }

    updateUser(user) {
        return this.http.put(this.appUrl, user, { headers: this.headers })
            .toPromise()
            .then(() => user);
    }

    getAllEvents(){
        return this.http.get(environment.activity+'/LionO360/2.0/API/CalendarEvent?organizationId='+this.user.organizationId)
            .toPromise()
            .then(res => res);
    }
    getAllFiles() {
        return this.http.get<any>(this.localAppUrl + 'allFiles')
            .toPromise()
            .then(res => res);
    }
    getAllTasks(){
        return this.http.get<any>(this.localAppUrl + 'allTasks')
            .toPromise()
            .then(res => res);
    }
    updateRegisterPhone(updateData){
        return this.http.post<any>(`${environment.appOrgUrlconfig}UserPhoneSubscription/RegisterPhone`, updateData)
        .toPromise()
        .then((res) => res);
    }

    getRegisteredCalenderConfig(vendorOAuthId: number): Observable<any>{
        return this.httpService.getAll(`${environment.vendorUrl}VendorOAuthRegistrationUser/VendorUser?vendorOAuthRegistrationId=${vendorOAuthId}`);
    }

    getUserPreference(): Observable<UserPreference>{
        return this.http.get<UserPreference>(`${environment.appOrgUrlconfig}UserPreference`);
    }

    saveUserPreference(savedUserPreference: UserPreference): Observable<UserPreference>{
        return this.http.post<UserPreference>(`${environment.appOrgUrlconfig}UserPreference`, savedUserPreference);
    }

    resetUserPreference(): Observable<UserPreference>{
        return this.httpService.put(`${environment.appOrgUrlconfig}UserPreference/ResetDefault`);
    }

    updateUserProfileImage(imageData:ProfileImageData){
        return this.http.post(`${this.appUrl}/ProfileImage`, imageData);
    }
}
